import { Space } from "components/Common/Space";
import { ExerciseHeader } from "components/Common/ExerciseHeader";
import {
  useUpdateChapterStudentProgress,
  useUpdateHomeworkStudentProgress,
} from "hooks/api/student-progress";
import { useRole } from "hooks/common";
import { useParams } from "react-router-dom";
import { DndContainer } from "./DndContainer";
import {
  TMoveWordsIntoGapsExercise,
  TMoveWordsIntoGapsExercisePayload,
} from "types/app/exercises";
import "./MoveWordsIntoGaps.styles.scss";

type TMoveWordsIntoGapsProps = {
  isHomeworkExercise: boolean;
  /**
   * Chapter ID to which the exercise belongs.
   */
  chapterId: number;
  /**
   * An exercise raw data from API response.
   */
  exercise: TMoveWordsIntoGapsExercise;
  /**
   * Lesson chapter order number with the exercise sequence number to display before the exercise condition.
   * @default null
   */
  prefix?: string | null;
};

export const MoveWordsIntoGaps: React.FC<TMoveWordsIntoGapsProps> = (props) => {
  const { chapterId, exercise, prefix = null, isHomeworkExercise } = props;

  const { courseId, lessonId, studentId } = useParams();
  const { isUserStudent } = useRole();

  const { mutate: updateChapterProgress } = useUpdateChapterStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );
  const { mutate: updateHomeworkProgress } = useUpdateHomeworkStudentProgress(
    courseId,
    lessonId,
    chapterId,
    studentId
  );

  const handleSaveExercise = (updatedExercise: TMoveWordsIntoGapsExercise) => {
    if (!isUserStudent || !studentId) return;

    if (isHomeworkExercise) {
      updateHomeworkProgress(updatedExercise);
    } else {
      updateChapterProgress(updatedExercise);
    }
  };

  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      <ExerciseHeader<TMoveWordsIntoGapsExercisePayload>
        chapterId={chapterId}
        prefix={prefix}
        exercise={exercise}
      />
      <DndContainer
        exerciseData={exercise.payload.data}
        exercise={exercise}
        onSaveExercise={handleSaveExercise}
      />
    </Space>
  );
};
